export enum CurrentFolderVariants {
  Screens = 'screens',
  Contents = 'contents',
  Playlists = 'playlists',
}
